<template>
  <div class="group-select row">
    <div
        v-for="group in this.$lodash().sortBy(groups, 'name')"
        :key="group.id"
        class="col-md-6"
    >
      <label>
        <input
            v-model="currentlySelectedGroupIds"
            type="checkbox"
            :value="group.id"
            :checked="isChecked(group.id)"
        >
        {{ group.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'group-select',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  computed: {
    groups () {
      return this.$store.getters.groups
    },
    selectedGroups () {
      return this.$store.getters.selectedGroups
    }
  },
  mounted () {
    if (this.modelValue.length > 0) {
      this.currentlySelectedGroupIds = this.modelValue
    } else if (this.selectedGroups.length) {
      this.setSelectedGroupsByDefault()
    }
  },
  data () {
    return {
      currentlySelectedGroupIds: []
    }
  },
  watch: {
    groups () {
      this.setIfOnlyOneGroupIsGiven()
    },
    currentlySelectedGroupIds (currentlySelectedGroupIds) {
      this.$emit('update:modelValue', currentlySelectedGroupIds)
    }
  },
  methods: {
    isChecked (idGroup) {
      return this.currentlySelectedGroupIds.includes(idGroup)
    },
    setSelectedGroupsByDefault () {
      var currentlySelectedGroupIds = []
      for (var i = 0; i < this.selectedGroups.length; i++) {
        currentlySelectedGroupIds.push(this.selectedGroups[i].id)
      }
      this.currentlySelectedGroupIds = currentlySelectedGroupIds
    }
  }
}
</script>

<style scoped>
</style>
